import type { OwnerScope } from '@vivport/backend/types';

export function ownerScopeToInputScope(ownerScope: OwnerScope): 'PRIVATE' | 'HUB' {
  return ownerScope === 'HUB' ? 'HUB' : 'PRIVATE';
}

export function inputScopeToOwnerScope(scope: 'PRIVATE' | 'HUB'): OwnerScope {
  return scope === 'HUB' ? 'HUB' : 'MEMBER';
}
